// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2D1Un","loader-animation":"Loader_loader-animation__11Hxq","light":"Loader_light__1wtIj","dark":"Loader_dark__2O6NY"};